let dirPath = 'static/games/page020_game3';

let configGame = {
  removeInCorrects: true,
  correctBlock: false,
  //autoCheckAllCorrect: true,
  removeAllFromBadTarget: false,
  rulesGame: {
    itemsConfig: {
      block: true,
    },
    otherProperty: {
      sounds: [{ src: dirPath + '/audio/klik.mp3', id: 'mouseup' }],
    },
    items: [
      {
        idGroup: 'mapa',
        idItem: 'legend',
        itemsConfig: {
          shuffle: true,
        },
        items: [
          {
            idGroup: 'source',
            idItem: '00',
            correct: [{ idGroup: 'mapa', idItem: 'legend', idHook: 'hook0' }],
          },
          {
            idGroup: 'source',
            idItem: '01',
            correct: [{ idGroup: 'mapa', idItem: 'legend', idHook: 'hook1' }],
          },
          {
            idGroup: 'source',
            idItem: '02',
            correct: [{ idGroup: 'mapa', idItem: 'legend', idHook: 'hook2' }],
          },
        ],
      },
    ],
  },
  layout: {
    itemsConfig: {
      positions: {
        margin: { left: 5, bottom: 5 },
      },
      background: {
        color: 'transparent',
        text: { size: '40px', textAlign: 'center', textBaseline: 'middle', font: 'Myriad Pro' },
      },
    },
    groups: [
      {
        idGroup: 'mapa',
        background: {
          color: 'transparent',
          //     color: 'pink',
        },
        positions: {
          type: 'absolute',
          pos: { x: 100, y: 0, height: 750, width: 1700 },
        },
        items: [
          {
            id: 'legend',
            positions: {
              autoFit: true,
            },
            otherProperty: {
              hooks: {
                background: {
                  color: 'green',
                },
                positions: {
                  type: 'absolute',
                  pos: { height: 55, width: 250 },
                },
                items: [
                  {
                    id: 'hook0',
                    background: {
                      color: '#00ff00',
                    },
                    positions: { pos: { x: 749, y: 495, height: 108, width: 547 } },
                  },
                  {
                    id: 'hook1',
                    background: {
                      color: '#f4b757',
                    },
                    positions: { pos: { x: 749, y: 715 - 110, height: 108, width: 547 } },
                  },
                  {
                    id: 'hook2',
                    background: {
                      color: '#af5d9c',
                    },
                    positions: { pos: { x: 749, y: 715, height: 108, width: 547 } },
                  },
                ],
              },
            },
          },
        ],
      },
      {
        idGroup: 'source',
        positions: {
          type: 'absolute',
          pos: { x: 1000, y: 0 },
          autoFit: true,
        },
        itemsConfig: {
          positions: {
            pos: { height: 55, width: 250 },
            margin: { top: 10 },
            columns: 1,
          },
          background: {
            color: '#ebebeb',
          },
        },
        items: [
          {
            id: '00',
            positions: {
              pos: { height: 108, width: 547 },
            },
            background: {
              text: { val: 'odejmowanie' },
            },
          },
          {
            id: '01',
            positions: {
              pos: { height: 108, width: 547 },
            },
            background: {
              text: { val: 'dodawanie' },
            },
          },
          {
            id: '02',
            positions: {
              pos: { height: 108, width: 547 },
            },
            background: {
              text: { val: 'równa się' },
            },
          },
        ],
      },
    ],
  },
};

let dataConfig = {
  mixinEngine: 'dnd',
  // isDev: true,
  //   defaultConfig: dirPath + '/defaultConfig.json',
  realHeight: 840,
  //   realWidth: 1820,
  mainImage: {
    imagePath: dirPath + '/img/bgr.png',
    pos: {
      y: 0,
      x: 0,
    },
    cssStyle: {
      positions: 'absolute',
      left: '-46px',
      top: '30px',
    },
  },
  configGame: configGame,
};

export default dataConfig;
